module.exports = __webpack_public_path__ + "static/media/sg3plus.ec594de0.png";